import { StorageConstant } from "../helper/constants";

export const setAuthLocalStorage = (res) => {
  localStorage.setItem(StorageConstant.IS_LOGGED_IN, true);
  localStorage.setItem(StorageConstant.LOGIN_HEADER, res.loginHeader);
  localStorage.setItem(StorageConstant.USER_TYPE, res.userType);
  if (res.isAffiliate !== undefined) {
    localStorage.setItem(StorageConstant.IS_AFFILIATE, res.isAffiliate ? 'true' : 'false');
  }
  if (res.isSeller !== undefined) {
    localStorage.setItem(StorageConstant.IS_SELLER, res.isSeller ? 'true' : 'false');
  }
};

export const getAuthLocalStorage = () => {
  const response = {};
  response.isLoggedIn = localStorage.getItem(StorageConstant.IS_LOGGED_IN);
  response.loginHeader = localStorage.getItem(StorageConstant.LOGIN_HEADER);
  response.userType = localStorage.getItem(StorageConstant.USER_TYPE);
  response.isAffiliate = localStorage.getItem(StorageConstant.IS_AFFILIATE) === 'true';
  response.isSeller = localStorage.getItem(StorageConstant.IS_SELLER);
  // Default isSeller to true if not set (backward compat for existing sellers)
  response.isSeller = response.isSeller === null ? true : response.isSeller === 'true';
  return response;
};

export const clearAuthLocalStorage = () => {
  localStorage.removeItem(StorageConstant.IS_LOGGED_IN);
  localStorage.removeItem(StorageConstant.LOGIN_HEADER);
  localStorage.removeItem(StorageConstant.USER_TYPE);
  localStorage.removeItem(StorageConstant.IS_AFFILIATE);
  localStorage.removeItem(StorageConstant.IS_SELLER);
  localStorage.removeItem('userType');
  localStorage.removeItem('assignedMenus');
};

export const setAuthVerifiedData = (res) => {
  localStorage.setItem(StorageConstant.VERIFIED_PHONE, res.phone);
  localStorage.setItem(StorageConstant.VERIFIED_EMAIL, res.email);
};

export const getAuthVerifiedData = () => {
  let response = {};
  response.verifiedPhone = localStorage.getItem(StorageConstant.VERIFIED_PHONE);
  response.verifiedEmail = localStorage.getItem(StorageConstant.VERIFIED_EMAIL);
  return response;
};

export const clearAuthVerifiedData = () => {
  localStorage.clear(StorageConstant.VERIFIED_PHONE);
  localStorage.clear(StorageConstant.VERIFIED_EMAIL);
};
